import React from "react";

/**
 * "Continue with Google" button — used on both /login and /register.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
const GoogleSignInButton = ({ label = "Continue with Google", testId = "google-signin" }) => {
  const start = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={start}
      className="btn-ghost-rugged w-full inline-flex items-center justify-center gap-3 text-sm"
    >
      <svg viewBox="0 0 48 48" className="w-4 h-4" aria-hidden="true">
        <path fill="#EA4335" d="M24 9.5c3.3 0 6.3 1.1 8.6 3.2l6.4-6.4C34.9 2.7 29.8 0.5 24 0.5 14.6 0.5 6.4 5.9 2.5 13.8l7.5 5.8C11.9 13.6 17.5 9.5 24 9.5z"/>
        <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.5 3-2.2 5.5-4.7 7.2l7.3 5.6c4.3-3.9 6.7-9.7 6.7-17.3z"/>
        <path fill="#FBBC05" d="M10 28.4c-.5-1.4-.8-2.9-.8-4.4s.3-3 .8-4.4l-7.5-5.8C.9 16.9 0 20.4 0 24s.9 7.1 2.5 10.2l7.5-5.8z"/>
        <path fill="#34A853" d="M24 47.5c6 0 11-2 14.7-5.4l-7.3-5.6c-2 1.4-4.6 2.2-7.4 2.2-6.5 0-12.1-4.1-14.1-9.8l-7.5 5.8C6.4 42.1 14.6 47.5 24 47.5z"/>
      </svg>
      {label}
    </button>
  );
};

export default GoogleSignInButton;
